'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Validate = function (_Component) {
  _inherits(Validate, _Component);

  function Validate(props) {
    _classCallCheck(this, Validate);

    var _this = _possibleConstructorReturn(this, (Validate.__proto__ || Object.getPrototypeOf(Validate)).call(this, props));

    _this.checkPatternMet = _this.checkPatternMet.bind(_this);
    _this.validationGetter = _this.validationGetter.bind(_this);
    _this.id = (0, _uuid2.default)();
    return _this;
  }

  _createClass(Validate, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      if (!this.shouldValidate()) return;

      this.context.registerValidate(this.validationGetter, this.id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.shouldValidate()) return;

      this.context.unregisterValidate(this.validationGetter, this.id);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.required !== this.props.required) {
        if (this.props.required) {
          return this.context.registerValidate(this.validationGetter, this.id);
        }

        return this.context.unregisterValidate(this.validationGetter, this.id);
      }
    }
  }, {
    key: 'checkPatternMet',
    value: function checkPatternMet(pattern) {
      return this.context.checkPatternMet(this.id, pattern);
    }
  }, {
    key: 'validationGetter',
    value: function validationGetter() {
      return {
        error: this.props.error,
        patterns: this.props.patterns,
        required: this.props.required,
        value: this.props.value
      };
    }
  }, {
    key: 'shouldValidate',
    value: function shouldValidate() {
      return this.props.patterns || this.props.required;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      if (!this.shouldValidate()) {
        return children();
      }

      var _context = this.context,
          getValidity = _context.getValidity,
          checkRequiredMet = _context.checkRequiredMet;


      return children(getValidity(this.id), checkRequiredMet(this.id), this.checkPatternMet);
    }
  }]);

  return Validate;
}(_react.Component);

Validate.contextTypes = {
  getValidity: _propTypes2.default.func,
  checkPatternMet: _propTypes2.default.func,
  checkRequiredMet: _propTypes2.default.func,
  registerValidate: _propTypes2.default.func,
  unregisterValidate: _propTypes2.default.func
};
Validate.propTypes = {
  /**
   * Function that returns React.node type and is provided with information
   * of the validity of the inputs state.
   *
   * @param {bool} isValid Inline validity state for that input
   * @param {bool} hasMetRequired Returns the current required validity
   * @param {function} checkPatternMet Takes a pattern and returns the
   * validity of that pattern
   */
  children: _propTypes2.default.func.isRequired,
  /**
   * Function that given the inputs invalidations, returns an error
   * message which is given by the top level Validator component.
   */
  error: _propTypes2.default.func,
  /**
   * Array of patterns to be run against this input.
   */
  patterns: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func.isRequired, _propTypes2.default.instanceOf(RegExp).isRequired]).isRequired),
  /** If this is a required field */
  required: _propTypes2.default.bool,
  /** Current value to run against the validations */
  value: _propTypes2.default.any
};
exports.default = Validate;